import { IonCol, IonIcon } from "@ionic/react";
import { backspaceOutline } from "ionicons/icons";
import styles from "./KeyPadButton.module.scss";

const KeyPadButton = (props: any) => {

    const { small, value, letters = "", remove, handleClick, isDisabled = false, compact = false } = props;

    return (
        <IonCol size="4" className={styles.colWrapper}>
            <button
                disabled={isDisabled}
                className={`${styles.circleButton} ${compact ? styles.compactCircle : ""} ${remove ? styles.removeButton : ""}`}
                onClick={handleClick}
                type="button"
            >
                {remove ? (
                    <IonIcon icon={backspaceOutline} className={styles.backspaceIcon} />
                ) : (
                    <>
                        <span className={styles.number}>{value}</span>
                        {letters && <span className={styles.letters}>{letters}</span>}
                    </>
                )}
            </button>
        </IonCol>
    );
}

export default KeyPadButton;
